import React, { Component } from 'react'
import { history } from '../../../../routing/History'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { Session } from '../../../../state/utils/session'
import { jsonPrettify } from '../../../../utils/jsonPrettify'

class ConnectionDetailsCard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }
    this.goToConnectionEditor = this.goToConnectionEditor.bind(this)
  }

  goToConnectionEditor () {
    history.push(
      ROUTING_PATHS.CLIENT_DASHBOARD_CONNECTION_EDITOR_PATH
        .replace(':connection_id', this.props.connection.id)
        .replace(':client_id', this.state.session.getClientSession())
    )
  }

  render () {
    return (
            <>
                <div className={'block block-themed' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                    <div className="block-header bg-primary-dark">
                        <ul className="block-options">
                            <li>
                                <button type="button" onClick={this.goToConnectionEditor}>
                                    <i className="fa fa-edit"></i>
                                </button>
                            </li>
                        </ul>
                        <h3 className="block-title">
                            <i className="fa fa-info-circle"></i> Details
                        </h3>
                    </div>
                    <div className="block-content">
                        <ul className="list list-activity push">
                            <li>
                                <div className="font-w600">ID:</div>
                                <div>{this.props.connection.id}</div>
                            </li>
                            <li>
                                <div className="font-w600">Connection name:</div>
                                <div>{this.props.connection.name}</div>
                            </li>
                            <li>
                                <div className="font-w600">Origin:</div>
                                <div>{this.props.connection.origin_type}</div>
                            </li>
                            <li>
                                <div className="font-w600">Parameters:</div>
                                <div>
                                    <pre>
                                        <code>
                                            {jsonPrettify(this.props.connection.parameters)}
                                        </code>
                                    </pre>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
    )
  }
}

// Set defaultProps
ConnectionDetailsCard.defaultProps = {
  connection: {}
}

// Export Class
export { ConnectionDetailsCard }
